import { Pipe, Injectable } from '@angular/core';
import { TitleService } from '@title-manager';
import { BatchUpgradeService } from './batch-upgrade.service';

@Injectable()
@Pipe({
    name: 'batchUpgradeIdToName',
    standalone: false
})
export class BatchIdToNamePipe implements TitleService {
    constructor(private service: BatchUpgradeService) { }

    public name: string = 'batchUpgradeIdToName';

    public transform(id: string): Promise<any> {
        return new Promise( async(resolve, reject) => {
            try {
                const upgrade = await this.service.getBatchUprade(id);
                resolve(upgrade.name);
            } catch (e) {
                console.error('Error while transforming Batch id to name! [BatchIdToNamePipe.transform]', e);
                resolve('');
            }
        });
    }
}
